interface SNS {
  facebook: boolean;
  apple: boolean;
  google: boolean;
}

interface Privilege {
  name: string;
  code: number;
}

interface User {
  id: number;
  username: string;
  email: string;
  fullname: string;
  avatar: string;
  country: string;
  sns: SNS;
  has_password_been_set: boolean;
  is_phone_verified: boolean;
  is_verified: boolean;
  privilege: Privilege;
  watchlist_id: number;
  exchange: string;
}

interface Access {
  token: string;
  expired_at: string;
}

interface Refresh {
  token: string;
  expired_at: string;
}

interface Support {
  id: string;
}

export interface LoginData {
  user: User;
  access: Access;
  refresh: Refresh;
  onesignal_hash: string;
  support: Support;
}

export interface ErrorHandlerProps {
  accountid: string;
  accountkey: string;
  email: string;
  fullname: string;
  type: string;
}

export interface ErrorResponse {
  response?: {
    data?: {
      message?: string;
      error_type?: string;
    };
    status: number;
  };
  message?: string;
}

export interface EmailLoginProps {
  username: string;
  password: string;
  verificationToken?: string;
  recaptchaVersion?:
    | 'RECAPTCHA_VERSION_UNSPECIFIED'
    | 'RECAPTCHA_VERSION_2'
    | 'RECAPTCHA_VERSION_3';
  resolveLoginErrorCallback?: () => void;
}

export interface SocialLoginProps {
  accessToken: string;
  accountId: string;
  resolveLoginErrorCallback: () => void;
}

export type TError = Error | string | null;

export interface State {
  emailLoginProps?: EmailLoginProps;
  isLoading: boolean;
  error: TError;
  message: string;
}

export interface Actions {
  setEmailLoginProps?: (props: EmailLoginProps) => void;
  startLoading: () => void;
  stopLoading: () => void;
  setError: (error: TError) => void;
}

export enum LoginType {
  LOGIN_DATA_TYPE_UNSPECIFIED = 'LOGIN_DATA_TYPE_UNSPECIFIED',
  LOGIN_DATA_TYPE_SUCCESS = 'LOGIN_DATA_TYPE_SUCCESS',
  LOGIN_DATA_TYPE_NEW_DEVICE = 'LOGIN_DATA_TYPE_NEW_DEVICE',
  LOGIN_DATA_TYPE_TRUSTED_DEVICE = 'LOGIN_DATA_TYPE_TRUSTED_DEVICE',
}
